import { Icon, Toast } from '@fattureincloud/fic-design-system'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'
import React, { FC, useEffect, useState } from 'react'

import { httpRequest } from '../../common/network'
import { errorMessage } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import ArticleReadOnlyMode from '../Articles/ArticleReadOnlyMode'
import {
  ArticleInfo,
  RelatedArticle,
  SidebarType,
  StatisticsArticle,
  TreeItem,
} from '../definitions'
import ElementNotFound from '../ElementNotFound'
import { SubarticleContent, SubarticleProps } from './subarticle.components'

export const SubArticleShow: FC<SubarticleProps> = (props: SubarticleProps) => {
  const [showContent, setShowContent] = useState<boolean>(false)
  const [parentsArticle, setParentsArticles] = useState<string[]>([])
  const [article, setArticle] = useState<ArticleInfo>()
  const visualizationMode = useAppSelector(
    (state) => state.visualizationMode.value
  )
  const adminMode = useAppSelector((state) => state.adminMode.value)
  const realm = useAppSelector((state) => state.realm.value)

  const getArticle = () => {
    httpRequest({
      method: 'GET',
      path: 'help/article/' + props.permalink,
      params: {
        realm: realm,
        visualize_mode: adminMode ? visualizationMode : 0,
        edit_mode: 0,
      },
      onSuccess: (response: {
        data: ArticleInfo
        related_articles: RelatedArticle[]
        sidebar: SidebarType
        tree: TreeItem
        statistics: StatisticsArticle
      }) => {
        setArticle(response.data)
      },
      onError: (res) => {
        Toast.error(errorMessage, { content: res.message })
      },
    })
  }

  useEffect(() => {
    props.parentsArticle.push(props.permalink)
    setParentsArticles(props.parentsArticle)
  }, [])

  const onShowHandler = () => {
    getArticle()
    if (parentsArticle.length > 3) {
      if (props.isInternal) {
        window.open('/help/articolo/' + props.permalink, '_blank')
      } else {
        props.changeView(props.permalink, 'articolo')
      }
    } else {
      setShowContent(!showContent)
    }
  }

  return (
    <div className={props.className}>
      <div
        className={showContent ? 'titleContent' : undefined}
        onClick={onShowHandler}
        style={{ cursor: 'pointer' }}
      >
        <span className='iconContainer'>
          <Icon icon={faAngleRight} />
        </span>
        <span className='title'>{props.text}</span>
      </div>
      {showContent && article && (
        <SubarticleContent>
          <ArticleReadOnlyMode
            article={article}
            changeView={props.changeView}
            parentsArticle={props.parentsArticle}
            isInternal={props.isInternal}
            searchKey={props.permalink}
            setReferences={() => console.log('set rft')}
            isExternal={true}
            subArticle={true}
            viewportWidth={900}
          />
        </SubarticleContent>
      )}
      {showContent && !article && (
        <ElementNotFound type={'article'} onClick={props.changeView} />
      )}
    </div>
  )
}
